export const WORLD_CUP_TEAMS = [
  "Mexico",
  "South Africa",
  "South Korea",
  "Czech Republic",
  "Canada",
  "Bosnia & Herzegovina",
  "Qatar",
  "Switzerland",
  "Brazil",
  "Morocco",
  "Haiti",
  "Scotland",
  "USA",
  "Paraguay",
  "Australia",
  "Turkey",
  "Germany",
  "Curaçao",
  "Ivory Coast",
  "Ecuador",
  "Netherlands",
  "Japan",
  "Sweden",
  "Tunisia",
  "Belgium",
  "Egypt",
  "Iran",
  "New Zealand",
  "Spain",
  "Cape Verde",
  "Saudi Arabia",
  "Uruguay",
  "France",
  "Senegal",
  "Iraq",
  "Norway",
  "Argentina",
  "Algeria",
  "Austria",
  "Jordan",
  "Portugal",
  "DR Congo",
  "Uzbekistan",
  "Colombia",
  "England",
  "Croatia",
  "Ghana",
  "Panama",
];

export const WORLD_CUP_TEAM_FLAG_CODES = {
  Mexico: "mx",
  "South Africa": "za",
  "South Korea": "kr",
  "Czech Republic": "cz",
  Canada: "ca",
  "Bosnia & Herzegovina": "ba",
  Qatar: "qa",
  Switzerland: "ch",
  Brazil: "br",
  Morocco: "ma",
  Haiti: "ht",
  Scotland: "gb-sct",
  USA: "us",
  Paraguay: "py",
  Australia: "au",
  Turkey: "tr",
  Germany: "de",
  Curaçao: "cw",
  "Ivory Coast": "ci",
  Ecuador: "ec",
  Netherlands: "nl",
  Japan: "jp",
  Sweden: "se",
  Tunisia: "tn",
  Belgium: "be",
  Egypt: "eg",
  Iran: "ir",
  "New Zealand": "nz",
  Spain: "es",
  "Cape Verde": "cv",
  "Saudi Arabia": "sa",
  Uruguay: "uy",
  France: "fr",
  Senegal: "sn",
  Iraq: "iq",
  Norway: "no",
  Argentina: "ar",
  Algeria: "dz",
  Austria: "at",
  Jordan: "jo",
  Portugal: "pt",
  "DR Congo": "cd",
  Uzbekistan: "uz",
  Colombia: "co",
  England: "gb-eng",
  Croatia: "hr",
  Ghana: "gh",
  Panama: "pa",
};

export function normalizeWorldCupTeam(team) {
  if (typeof team === "string") return team;
  return team?.name || team?.team || "";
}

export function getWorldCupTeams(game) {
  const teams = game?.teams?.length ? game.teams : WORLD_CUP_TEAMS;
  return teams.map(normalizeWorldCupTeam).filter(Boolean);
}

export function getWorldCupTeamFlagIcon(teamName) {
  const code = WORLD_CUP_TEAM_FLAG_CODES[teamName];
  return code ? `circle-flags:${code}` : "mdi:flag-outline";
}

export const DEFAULT_PRIZE_POOL_AMOUNT = 1000000;

export const DEFAULT_WORLD_CUP_PAYLOAD = {
  name: "FIFA World Cup 2026",
  teams: WORLD_CUP_TEAMS,
  prizePoolAmount: DEFAULT_PRIZE_POOL_AMOUNT,
  tournamentYear: 2026,
};

export function buildWorldCupPayload(
  prizePoolAmount = DEFAULT_PRIZE_POOL_AMOUNT,
) {
  return {
    ...DEFAULT_WORLD_CUP_PAYLOAD,
    prizePoolAmount: Number(prizePoolAmount),
  };
}

export const WORLD_CUP_GAMES_STORAGE_KEY = "worldCupGames";

export function getSavedWorldCupGames() {
  try {
    const saved = localStorage.getItem(WORLD_CUP_GAMES_STORAGE_KEY);
    if (!saved) return [];

    const parsed = JSON.parse(saved);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveWorldCupGames(games) {
  localStorage.setItem(WORLD_CUP_GAMES_STORAGE_KEY, JSON.stringify(games));
}

export function getWorldCupGameById(gameId) {
  if (!gameId) return null;

  return (
    getSavedWorldCupGames().find(
      (game) => String(game?._id || game?.id) === String(gameId),
    ) ?? null
  );
}
